import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import EditProfileForm from '../../../components/ecommerce/forms/edit-profile/edit-profile-form.component';
import Loader from '../../../components/commons/helpers/loader/loader.component';
import './edit-profile.styles.scss';
import { getAccountPageData } from '../../../js/api/create-account/_create-account.data';
import ShoppingCartHeader from '../../../components/commons/shopping-cart-header/shopping-cart-header';

function EditProfile() {
  const [responseMainContent, setResponseMainContent] = useState({});

  const [responseDropDownContent, setResponseDropDownContent] = useState({});
  const [status, setStatus] = useState(null);
  const [noContent] = useState(204);

  useEffect(() => {
    const fetchData = async () => {
      const getResponse = await getAccountPageData();
      if (getResponse) {
        setStatus(getResponse.status);
        setResponseMainContent(getResponse.MainContent);
        setResponseDropDownContent(getResponse.CustomDropDownContent);
      }
    };
    fetchData();
  }, []);

  if (
    status === noContent ||
    (responseMainContent &&
      responseDropDownContent &&
      responseDropDownContent.Country !== undefined)
  ) {
    return (
      <>
        <ShoppingCartHeader text={'Edit Profile'} className="ep-header" />
        <Row className="edit-profile-page trinity-container">
          <EditProfileForm
            data={responseDropDownContent}
            mainData={responseMainContent}
            status={status}
          />
        </Row>
      </>
    );
  }
  return <Loader />;
}
export default EditProfile;
